import {
  isRecurrenceInterval,
  MIN_RECURRING_COUNT,
  RECURRENCE_FREQUENCY,
  RecurrenceRule,
} from "@/offering/recurrence";

// The repeat rule rides the URL as `repeat=weekly:<interval>:<count>` so it
// survives Continue, refresh and shared links the way every other picker value
// does. Only the rule travels: the dates are re-derived from the availability
// horizon on load, because a date list in the URL would go stale the moment
// someone else booked one of them.
export function parseRepeatParam(value?: string): RecurrenceRule | undefined {
  if (!value) return undefined;
  const [frequency, intervalStr, countStr] = value.split(":");
  if (frequency !== RECURRENCE_FREQUENCY) return undefined;

  const interval = Number(intervalStr);
  const count = Number(countStr);
  if (!Number.isInteger(interval) || !isRecurrenceInterval(interval)) {
    return undefined;
  }
  if (!Number.isInteger(count) || count < MIN_RECURRING_COUNT) {
    return undefined;
  }

  return { interval, count };
}

export function formatRepeatParam(rule: RecurrenceRule): string {
  return `${RECURRENCE_FREQUENCY}:${rule.interval}:${rule.count}`;
}
